import { render, staticRenderFns } from "./occupationInfoPath.vue?vue&type=template&id=2b3264f3&scoped=true"
import script from "./occupationInfoPath.vue?vue&type=script&lang=js"
export * from "./occupationInfoPath.vue?vue&type=script&lang=js"
import style0 from "./occupationInfoPath.vue?vue&type=style&index=0&id=2b3264f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3264f3",
  null
  
)

export default component.exports